import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent.js'
import KontingentperiodeService from "../../../services/KontingentperiodeService";
import KontingentService from "../../../services/KontingentService";
import KontingentperiodeDto from "../KontingentperiodeDto";
import Navigation from "../../Navigation/Navigation";

import '../../../components/Tile/Tile'
import '../../../components/Tile/TileGroup'
import BerechtigungUtil from "../../../services/BerechtigungUtil";
import EinladungService from "../../Einladung/EinladungService";

export default class VNBDashboard extends WebComponent {

  constructor() {
    super()
    this.kontingentperiodeService = new KontingentperiodeService()
    this.kontingentService = new KontingentService()
    this.einladungService = new EinladungService('vnb', new BerechtigungUtil().getActiveProfile().vnbExtId)
  }

  get translationFile() {
    return './views/Dashboard/VNB/i18n.json'
  }

  get showWeiterePendenzen() {
    return this.showOffeneEinladungen
  }

  get showOffeneEinladungen() {
    return this.offeneEinladungenCount > 0
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.kontingentperiodeService.list()
    ]).then(([json]) => {
      this.perioden = json?.map(it => new KontingentperiodeDto(it))
    })
      .finally(() => {
        this.offeneEinladungenCount = 0
        this.render()
        this.fetchStatistics()
        this.fetchWeiterePendenzen()
      })
  }

  getTemplate() {
    const aktiveKontingentierung = this.getAktiveKontingentierung()

    return html`
    ${aktiveKontingentierung ? aktiveKontingentierung : this.getEmpty()}
    ${this._getWeiterePendenzen()}
    `
  }

  getAktiveKontingentierung() {
    if (this.perioden?.length) {
      return html`
        <isceco-title id="page-title" text="${this.i18n.translate('dashboard.vnb.kontingentierung.aktiv')}">
        </isceco-title>
        <isceco-link text="${this.i18n.translate('dashboard.vnb.kontingentierung.link')}"
                     icon="external alternate icon"></isceco-link>

        ${this.perioden.map( periode => this.getPeriode(periode) )}
      `
    }
    return null
  }

  getPeriode(periode) {
    const title = periode.start < new Date() ? 'dashboard.vnb.kontingentierung.periode.laufend' : 'dashboard.vnb.kontingentierung.periode.naechste'
    return html`
      <isceco-title size="small" text="${this.i18n.translate(title, {date: formatDate(periode.start)})}">
      </isceco-title>
      <eko-tile-group>
        <eko-tile text="${this.i18n.translate('dashboard.vnb.kachel.verfuegung.neu.text')}"
                  description="${this.i18n.translate('dashboard.vnb.kachel.verfuegung.neu.description')}"
                  .count="${periode.neu}" @click="${() => this.openNeue(periode.id)}" ?hidden="${!periode.neu}">
          <i class="huge icons" slot="icon">
            <i class="file alternate outline icon"></i>
            <i class="green corner add icon"></i>
          </i>
        </eko-tile>
        <eko-tile text="${this.i18n.translate('dashboard.vnb.kachel.verfuegung.pendent.text')}"
                  description="${this.i18n.translate('dashboard.vnb.kachel.verfuegung.pendent.description')}"
                  .count="${periode.versendet}" @click="${() => this.openPendent(periode.id)}" ?hidden="${!periode.versendet}">
          <i class="huge icons" slot="icon">
            <i class="file alternate outline icon"></i>
            <i class="blue corner envelope icon"></i>
          </i>
        </eko-tile>
      </eko-tile-group>
    `
  }

  getEmpty() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('dashboard.vnb.title')}">
      </isceco-title>
    `
  }

  fetchStatistics() {
    for (const periode of this.perioden) {
      this.kontingentService.count({periodeId: periode.id, status: 'NEU'}).then( count => {
        periode.neu = count
        this.render()
      })
      this.kontingentService.count([
        ['periodeId', periode.id],
        ['status', 'VERSENDET_ELEKTRONISCH'],
        ['status', 'VORBEREITET_POSTALISCH'],
        ['status', 'VERSENDET_POSTALISCH']
      ]).then( count => {
        periode.versendet = count
        this.render()
      })
    }
  }

  fetchWeiterePendenzen() {
    this.einladungService.count(null, 'gp')
      .then(count => {
        this.offeneEinladungenCount = count
        this.render()
      })
  }

  _getWeiterePendenzen() {
    if (!this.showWeiterePendenzen) {
      return html``
    }
    return html`
      <isceco-title
        id="weitere-pendenzen-title"
        text="${this.i18n.translate('dashboard.vnb.kontingentierung.weitere.pendenzen')}"
        size="medium"
      ></isceco-title>
      <eko-tile-group>
       ${this._getOffeneEinladungenTile()}
      </eko-tile-group>
    `
  }

  _getOffeneEinladungenTile() {
    if (!this.showOffeneEinladungen) {
      return html``
    }

    return html`
      <eko-tile
        text="${this.i18n.translate('dashboard.vnb.kachel.verfuegung.weitere.pendenzen.vnb.onboarding')}"
        description="${this.i18n.translate('dashboard.vnb.kachel.verfuegung.weitere.pendenzen.vnb.offene.einladungen')}"
        .count="${this.offeneEinladungenCount}"
        @click="${() => this._gotoOffeneEinladungen()}"
      >
        <i class="huge icons" slot="icon">
          <i class="envelope open text icon"></i>
          <i class="corner blue user icon"></i>
        </i>
      </eko-tile>
    `
  }

  _gotoOffeneEinladungen () {
    navigate({
      to: Navigation.ROUTES.vnbDashboardOffeneEinladungen.url,
      allow: true
    })
  }

  openNeue = periodeId => {
    navigate({
      to: Navigation.ROUTES.verfuegungNeu.url,
      id: periodeId,
      allow: true
    })
  }

  openPendent = periodeId => {
    navigate({
      to: Navigation.ROUTES.verfuegungPendent.url,
      id: periodeId,
      allow: true
    })
  }

}
customElements.define('eko-frontend-vnb-dashboard', VNBDashboard)
